var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightThin = function SvgArrowRightThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.17 16a.67.67 0 0 0 .464-.185l7.707-7.333a.665.665 0 0 0 0-.964L4.634.185a.673.673 0 0 0-1.088.24.66.66 0 0 0 .16.723L10.91 8l-7.202 6.851A.665.665 0 0 0 4.172 16"
  })));
};
export default SvgArrowRightThin;